import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';
import WrFileInput from 'ember-wiser/components/form/controls/file-input';
import FileAttachmentDisplayer from 'parog-web/components/file-attachment-displayer';

interface Signature {
  Args: {
    form: WrFormComponentSignature<
      EmberChangeset,
      unknown
    >['Blocks']['default'][0];
    /** this will be displayed in header row */
    title: string;
  };
}

export default class FileAttachementRowComponent extends Component<Signature> {
  get fileAttachment() {
    return this.args.form.data?.orderedFileAttachments?.[0];
  }

  upload = (_value: string, event: Event) => {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      this.args.form.data?.rollbackProperty('fileAttachmentsAttributes');
      return;
    }

    // construct file attachement attribute
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result as string;
      const fileAttachment = {
        mimeType: result.split(';')[0].split(':')[1],
        index: 0,
        fileContentAttributes: {
          data: result.split(',')[1]
        }
      };

      if (!this.args.form.data) return;
      this.args.form.data.fileAttachmentsAttributes = [fileAttachment];
    };

    reader.readAsDataURL(file);
  };

  <template>
    <@form.Row>
      <:header>{{@title}}</:header>
      <:col1>
        {{#if this.fileAttachment}}
          <FileAttachmentDisplayer
            @shouldDisplayTextWithDownloadIcon={{true}}
            @fileAttachment={{this.fileAttachment}}
            @alternativeText='pièce jointe'
          />
        {{else}}

          <div class='pt-2 sm:pt-0' aria-label='fileUpload'>
            <WrFileInput
              @onChange={{this.upload}}
              accept='application/pdf,image/jpeg,image/jpg,image/png,application/rtf'
            />
          </div>

        {{/if}}

      </:col1>
    </@form.Row>
  </template>
}
